import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import moment from 'moment-timezone';

moment.tz.setDefault("Europe/Moscow");

Vue.config.productionTip = false;
Vue.config.local = false;

Vue.prototype.axios = window.axios = axios;

axios.defaults.baseURL = '/';
Vue.prototype.$hostname = '';

if (location.host === 'localhost:8080') {
	Vue.config.local = true;
	axios.defaults.baseURL = 'http://sport-beeline.roscontent.ru/';
	Vue.prototype.$hostname = 'http://sport-beeline.roscontent.ru/';
	Vue.config.productionTip = true;
}

window.isVisible = function ($block, offset) {
	if (!$block.length) return;
	
	var blockTop = $block.offset().top,
		blockHeight = $block.innerHeight(),
		scrollTop = $(window).scrollTop(),
		windowHeight = $(window).height();

	offset = offset || 0;

	return !!(scrollTop >= (blockTop - windowHeight + offset)
		&& scrollTop < blockTop + blockHeight);
};

window.events = new Vue();

window.auth = false;
window.subscribed = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
